import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

import styles from './styles.module.scss';

interface IButtonProps
  extends React.HTMLAttributes<HTMLButtonElement | HTMLAnchorElement> {
  type?: 'button' | 'submit';
  variant?: 'primary' | 'secondary' | 'icon' | 'dark';
  to?: string;
  href?: string;
  disabled?: boolean;
}
const Button: React.FC<IButtonProps> = ({
  variant = 'primary',
  type = 'button',
  className,
  children,
  to = '',
  href = '',
  ...rest
}) => {
  const renderLink = () => {
    if (to) {
      return (
        <Link
          to={to}
          className={classNames(styles.button, styles[variant], className)}
        >
          {children}
        </Link>
      );
    } if (href) {
      return (
        <a
          href={href}
          className={classNames(styles.button, styles[variant], className)}
          target="_blank"
          rel="noopner noreferrer"

        >
          {children}
        </a>
      );
    }
    return null;
  };
  return renderLink() || (
    <button
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={classNames(styles.button, styles[variant], className)}
      {...rest}
    >
      {children}
    </button>
  );
};
export default Button;
